module.exports = __webpack_public_path__ + "img/inventoryCheck.a43a1dbc.png";